const constant = { 
    // excel 文件类型
    excelFileType:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/wps-office.xls'
};

export default constant



// WEBPACK FOOTER //
// ./src/common/constant.js